import apiUrl from "../../../utils/settings";


export const getHomepageDataUrl = () => {
    return apiUrl + '/v2/home';
}

export const getDashboardConfigUrl = () => {
    return apiUrl + '/company/dashboard-config';
}